import { useForm } from 'react-hook-form'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import { BpLink } from '../../../../shared/components/text/link/BpLink'
import { FormHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import { EMAIL_REGEX } from '../../../../shared/consts/RegularExpressions.const'
import styles from './ResetPasswordForm.module.scss'

export interface IResetPasswordFormData {
  email: string
}

export interface IResetFormProps extends FormHTMLAttributes<HTMLFormElement> {
  submitHandler?: (data: IResetPasswordFormData) => void
  isFetching?: boolean
}

export const ResetPasswordForm = ({
  submitHandler,
  isFetching = false,
  ...formProps
}: IResetFormProps) => {
  const { t } = useTranslation()
  const {
    handleSubmit,
    register,
    formState: { errors, isValid },
  } = useForm<IResetPasswordFormData>({
    mode: 'onChange',
    defaultValues: {
      email: '',
    },
  })

  return (
    <>
      <h2 className={styles.title}>{t('pages.auth.resetPassword')}</h2>
      <form
        {...formProps}
        className={styles.form}
        onSubmit={handleSubmit((data: IResetPasswordFormData) => {
          if (submitHandler) submitHandler(data)
        })}
      >
        <BpInput
          error={errors.email?.message}
          fieldSize='lg'
          label={t('pages.auth.email')}
          {...register('email', {
            required: t('fields.validate.emailRequired'),
            pattern: {
              value: EMAIL_REGEX,
              message: t('fields.validate.enterValidEmail'),
            },
          })}
        />
        <div className={styles.actions}>
          <BpButton disabled={!isValid || isFetching} size='lg' type='submit'>
            {t('pages.auth.buttons.sendResetLink')}
          </BpButton>
        </div>
        <div className={styles.linkWrap}>
          <BpLink to='/auth'>{t('pages.auth.buttons.goBackToLogin')}</BpLink>
        </div>
      </form>
    </>
  )
}
